import CTA6 from './CTA6'
export default CTA6
